import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BedIcon(props: IconProps) {
    return <Icon {...props} iconKey={"bed"}/>
}
